import { useState } from "react"
import { bool, func, object, string } from "prop-types"
import { Icon } from "source/shared/components"

HouseholdRoleSection.propTypes = {
  allOtherParents: bool.isRequired,
  canEditChildAdult: bool.isRequired,
  child: object.isRequired,
  hasOtherHouseholdMembers: bool.isRequired,
  householdName: string,
  householdRole: object.isRequired,
  onHouseholdRoleChange: func.isRequired,
  parentsGuardiansEnabled: bool.isRequired,
  updateAttributes: func.isRequired,
}

export function HouseholdRoleSection({
  allOtherParents,
  canEditChildAdult,
  child,
  hasOtherHouseholdMembers,
  householdName,
  householdRole,
  onHouseholdRoleChange,
  parentsGuardiansEnabled,
  updateAttributes,
}) {
  const [showInfo, setShowInfo] = useState(false)

  const disableHouseholdRoleUpdate =
    allOtherParents &&
    householdRole.attributes.household_role !== "parent_guardian"

  const helperShelfInfo = () => {
    if (disableHouseholdRoleUpdate)
      return "Households cannot contain only parents and guardians. Add a child, dependent or another adult to continue."
    else if (!canEditChildAdult)
      return `When editing your own profile, you can't edit Child/Adult${hasOtherHouseholdMembers ? " but you can check off Parent/guardian if you are an adult" : ""}.`
  }

  const displayHelperInfoButton =
    (disableHouseholdRoleUpdate && !child.attributes.child) ||
    !canEditChildAdult

  if (!parentsGuardiansEnabled) return null

  return (
    <fieldset>
      {householdName && (
        <legend className="fw-500 mb-1 c-tint0">{`${householdName} role`}</legend>
      )}
      <div className="d-f g-1 ai-c">
        <div className="d-f g-1">
          <div>
            <input
              type="radio"
              id="adult"
              name="child"
              className="radio"
              checked={!child.attributes.child}
              onChange={() => {
                updateAttributes(child, { child: false })
                const newRole = onHouseholdRoleChange()
                updateAttributes(householdRole, {
                  household_role: newRole,
                })
              }}
              {...(!canEditChildAdult && {
                disabled: true,
                "aria-describedby": "household-role-helper",
              })}
            />
            <label htmlFor="adult" className="radio-label">
              Adult
            </label>
          </div>
          <div>
            <input
              type="radio"
              id="child"
              name="child"
              className="radio"
              checked={child.attributes.child}
              onChange={() => {
                updateAttributes(child, { child: true })
                updateAttributes(householdRole, {
                  household_role: "child_or_dependent",
                })
              }}
              {...(!canEditChildAdult && {
                disabled: true,
                "aria-describedby": "household-role-helper",
              })}
            />
            <label htmlFor="child" className="radio-label">
              Child
            </label>
          </div>
        </div>
        {!child.attributes.child && hasOtherHouseholdMembers && (
          <div className="d-f ai-c ml-2">
            <input
              type="checkbox"
              id="household_role"
              name="household_role"
              className="checkbox"
              checked={
                householdRole.attributes.household_role === "parent_guardian"
              }
              onChange={(e) => {
                const role = e.target.checked
                  ? "parent_guardian"
                  : onHouseholdRoleChange()
                updateAttributes(householdRole, {
                  household_role: role,
                })
              }}
              disabled={disableHouseholdRoleUpdate}
            />
            <label htmlFor="household_role" className="checkbox-label">
              Parent/guardian
            </label>
          </div>
        )}
        {displayHelperInfoButton && (
          <button
            type="button"
            className="btn link-btn p-0"
            onClick={() => setShowInfo(!showInfo)}
            aria-label="Toggle information"
          >
            <Icon
              symbol="general#outlined-exclamation-circle"
              className="fs-4 c-tint2"
            />
          </button>
        )}
      </div>
      {displayHelperInfoButton && (
        <div
          className={`alert ${showInfo ? "" : "visually-hidden"}`}
          id="household-role-helper"
        >
          {helperShelfInfo()}
        </div>
      )}
    </fieldset>
  )
}
